<section class="services-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
           
            <h2>{{title}}</h2>
            <p>{{detail}}</p>
        </div>

        <div class="row">
            
            <div [ngClass]="class" *ngIf="box1title">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon">
                        <i class="flaticon-megaphone"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                            <div class="circle-two"></div>
                        </div>
                    </div>
                    <h3><a>{{box1title}}</a></h3>
                    <p>{{box1Detail}}</p>
                </div>
            </div>



            <div [ngClass]="class" *ngIf="box2title">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon">
                        <i class="flaticon-keywords"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                            <div class="circle-two"></div>
                        </div>
                    </div>
                    <h3><a>{{box2title}}</a></h3>
                    <p>{{box2Detail}}</p>
                </div>
            </div>
            <div [ngClass]="class" *ngIf="box3title">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon">
                        <i class="flaticon-content-management"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                            <div class="circle-two"></div>
                        </div>
                    </div>
                    <h3><a>{{box3title}}</a></h3>
                    <p>{{box3Detail}}</p>
                </div>
            </div>
            <div [ngClass]="class" *ngIf="box4title">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon">
                        <i class="flaticon-ppc"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                            <div class="circle-two"></div>
                        </div>
                    </div>
                    <h3><a>{{box4title}}</a></h3>
                    <p>{{box4Detail}}</p>
                </div>
            </div>
            <div [ngClass]="class" *ngIf="box5title">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon">
                        <i class="flaticon-competitor"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                            <div class="circle-two"></div>
                        </div>
                    </div>
                    <h3><a>{{box5title}}</a></h3>
                    <p>{{box5Detail}}</p>
                </div>
            </div>
            <div [ngClass]="class" *ngIf="box6title">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon">
                        <i class="flaticon-startup"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                            <div class="circle-two"></div>
                        </div>
                    </div>
                    <h3><a>{{box6title}}</a></h3>
                    <p>{{box6Detail}}</p>
                </div>
            </div>            
        </div>
    </div>
</section>